import React from 'react';
import { useSelector } from 'react-redux';

import { roundNumber, calculateProcessingFee } from '../../lib/utils';

export default function TransactionSummary() {
  const { paymentMethods, selected } = useSelector((state) => state.paymentMethods);
  const { amount } = useSelector((state) => state.product);
  const currencies = useSelector((state) => state.currencies);

  const selectedPaymentMethod = paymentMethods.find((pm) => pm.type === selected);

  const processingFee = calculateProcessingFee(amount, selectedPaymentMethod);

  const processingFeeString = `${roundNumber(currencies.sender.rate * processingFee, 2)} ${
    currencies.sender.name
  }`;

  const totalString = `${roundNumber(
    roundNumber(currencies.sender.rate * processingFee, 2) +
      roundNumber(currencies.sender.rate * amount, 2),
    2
  )} ${currencies.sender.name}`;

  const amountString = `${roundNumber(currencies.sender.rate * amount, 2)} ${
    currencies.sender.name
  }`;

  return (
    <div className="transaction-summary">
      <h3 className="title">Transaction summary</h3>
      <div className="amount summary">
        <div className="label">Amount</div>
        <div className="value">{amountString}</div>
      </div>
      <div className="fees summary">
        <div className="label">Processing fees</div>
        <div className="value">{processingFeeString}</div>
      </div>
      <div className="separator"></div>
      <div className="total summary">
        <div className="label">TOTAL</div>
        <div className="value">{totalString}</div>
      </div>
    </div>
  );
}
